/**
 * Created by litao on 2018/10/8.
 */
export default (http) => {
    return {
        /**
         * 查询字典列表
         * @param data
         * @return {*}
         */
        queryByPage(data) {
            return http.json({
                url: '/rep/wk/queryByPage',
                data
            })
        },
        updateState(data) {
            return http.json({
                url: `/rep/wk/updateState`,
                data
            })
        },
        tuijian(data) {
            return http.json({
                url: `/rep/wk/updateSuggested`,
                data
            })
        },

        getInfo(data) {
            return http.json({
                url: `/rep/wk/get?id=${data.id}`,
                data
            })
        },
        delete(data) {
            return http.json({
                url: `/rep/wk/delete`,
                data
            })
        },
    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/enroll/wk.js